export class TypesHelper {

   /**
   * Checks if given number | string is a integer.
   *
   * @param value [number | string]
   * @returns [boolean]
   */
   public static isInteger10(value: number | string): boolean {
      let num: number;
      let str: string;

      // value can be number of string
      if (typeof value === 'number') {
         // to string
         str = value + '';

         // integer
         num = parseFloat(str);
         if (Math.trunc(num) !== num) {
            return false;
         }

         // point
         num = parseFloat(str);
         if (str.indexOf('.') >= 0) {
            return false;
         }

         // ok
         return true;
      }

      // empty
      str = value;
      if (str.trim().length === 0) {
         return false;
      }

      // 0
      if (str.trim() === '0') {
         // ok
         return true;
      }

      // number
      num = ~~str;
      if (isNaN(num) || num === 0) {
         return false;
      }

      // integer
      num = parseFloat(str);
      if (Math.trunc(num) !== num) {
         return false;
      }

      // point
      if (str.indexOf('.') >= 0) {
         return false;
      }

      // 0 at start
      if (str.charAt(0) === '0') {
         return false;
      }

      // ok
      return true;
   }

   /**
   * Checks if given number | string is a number.
   *
   * @param value [number | string]
   * @returns [boolean]
   */
   public static isNumber(value: number | string) {
      // value can be number of string
      if (typeof value === 'number') {
         // ok
         return true;
      }

      // empty
      const str: string = value;
      if (str.trim().length === 0) {
         return false;
      }

      // 0
      if (str.trim() === '0') {
         // ok
         return true;
      }

      // number
      const num: number = +str;
      if (isNaN(num) || num === 0) {
         return false;
      }

      // ok
      return true;
   }

   /**
   * Convert given number | string to a integer.
   * Throw exception if given string is not a integer. To prevent exception
   * check type with function isInteger of this class.
   *
   * @param value [number | string]
   * @returns [boolean]
   */
   public static toInteger10(value: number | string): number {
      let num: number;
      let str: string;

      // value can be number of string
      if (typeof value === 'number') {
         // to string
         str = value + '';

         // integer
         num = parseFloat(str);
         if (Math.trunc(num) !== num) {
            throw Error('Value is not an integer');
         }

         // point
         num = parseFloat(str);
         if (str.indexOf('.') >= 0) {
            throw Error('Value is not an integer');
         }

         // ok
         return value;
      }

      // empty
      str = value;
      if (str.trim().length === 0) {
         throw Error('Value is not an integer');
      }

      // 0
      if (str.trim() === '0') {
         // ok
         return parseInt(value, 10);
      }

      // number
      num = ~~str;
      if (isNaN(num) || num === 0) {
         throw Error('Value is not an integer');
      }

      // integer
      num = parseFloat(str);
      if (Math.trunc(num) !== num) {
         throw Error('Value is not an integer');
      }

      // point
      if (str.indexOf('.') >= 0) {
         throw Error('Value is not an integer');
      }

      // 0 at start
      if (str.charAt(0) === '0') {
         throw Error('Value is not an integer');
      }

      // ok
      return parseInt(value, 10);
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/library/types-helper.ts